import React from 'react'
import clx from 'classnames'
import { Source } from '@/app/constants/import/source'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { FaIcon } from '@/lib/fa'
import { getSourceIcon } from '../pages/home/components/import-review/utils'
import { getSourceName } from '@/app/common/converters/import/sourceToTextConverter'
import styles from './styles.module.css'
import { DriverVehicleImportItem, VehicleImportItem } from '../model/imports.state.types'
import { formatDate } from '@/modules/shared/utils/date'

export type VehicleUsedTableItem = {
  usedVehicle: DriverVehicleImportItem
  sources: Source[]
  vehicle: VehicleImportItem
  originalFirstUse?: string // original before clipping by dateFrom
}

type VehicleUsedTableProps = {
  vehicles: VehicleUsedTableItem[]
  className?: string
}

export const VehicleUsedTable: React.FC<VehicleUsedTableProps> = ({
  vehicles,
  className,
}) => {
  const { t } = useLocalize()

  if (!vehicles.length) return null

  return (
    <div className={clx('tw-px-4 tw-pb-3', className)}>
      <div className="tw-overflow-hidden tw-rounded-lg tw-border tw-border-slate-200">
        {/* Header */}
        <div
          className={clx(
            'tw-grid tw-items-center tw-bg-slate-50 tw-px-3 tw-py-2 tw-text-xs tw-font-medium tw-text-slate-500',
            styles.vehicleGrid,
          )}
        >
          <div>{t('importModule.col-registration')}</div>
          <div>{t('importModule.col-data-source')}</div>
          <div>{t('importModule.col-usage-range')}</div>
        </div>

        {/* Rows */}
        <div className="tw-divide-y tw-divide-slate-100">
          {vehicles.map((v) => {
            return (
            <div
              key={v.usedVehicle.id}
              className={clx(
                'tw-grid tw-items-center tw-bg-white tw-px-3 tw-py-2 tw-text-sm hover:tw-bg-slate-50',
                styles.vehicleGrid,
              )}
            >
              {/* Registration */}
              <div className="tw-font-medium tw-text-slate-900">
                {v.usedVehicle.registrationNumber}
              </div>

              {/* Sources */}
              <div className="tw-flex tw-flex-col tw-gap-1 tw-text-slate-700">
                {v.sources.map((s, i) => (
                  <span key={`${v.usedVehicle.id}-${s}-${i}`} className="tw-inline-flex tw-items-center tw-gap-1">
                    <FaIcon icon={getSourceIcon(s)} />
                    {getSourceName(s, t)}
                  </span>
                ))}
              </div>

              {/* Usage range */}
              <div className="tw-text-slate-700">
                <span
                  className={clx(
                    'tw-text-slate-900',
                    v.originalFirstUse && 'tw-italic tw-text-amber-600',
                  )}
                  title={v.originalFirstUse ? `Oryginalna data: ${formatDate(v.originalFirstUse, 'YYYY-MM-DD')}` : undefined}
                >
                  {formatDate(v.usedVehicle.firstUse, 'YYYY-MM-DD')}
                </span>
                <span className="tw-mx-2 tw-text-slate-400">–</span>
                <span className="tw-text-slate-900">{formatDate(v.usedVehicle.lastUse, 'YYYY-MM-DD')}</span>
              </div>


            </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
